const Grid = ({ list }) => {
  const normalizedData = {
    list: list,
  };

  return normalizedData;
};

export default Grid;
